import { useMemo } from "react";
import { merge } from "lodash";
import { isNullish } from "../../../lib/util/common-util";
import { AnnualReportSaved } from "../../../lib/object/entity/annual-report";
import { AnnualReportViewModel } from "../../../lib/object/vm/annual-report-view-model";
import { useAppGetAnnualReportQuery } from "../../query/use-app-get-annual-report-query";
import { useAnnualReportVM } from "./use-annual-report-vm";

export function useAnnualReportReadonlyVm(
  documentId: number | null | undefined,

  options?: {
    /**
     * skipがtrueの場合、何も行わない。
     */
    skip: boolean;
  },
): {
  currentData: AnnualReportSaved | null;
  vm: AnnualReportViewModel | null;
} {
  const _options = useMemo(() => merge({ skip: false }, options), [options]);

  const { currentData } = useAppGetAnnualReportQuery(
    { documentId: documentId ?? -1 },
    { skip: _options.skip || isNullish(documentId) },
  );

  const vm = useAnnualReportVM(currentData);
  return { currentData, vm };
}
